import "./css/index.css"
import { render } from "preact"
import { Routes } from "./app/route.tsx"
import * as Sentry from "@sentry/react"
import { BlogBootstrapProvider } from "./blog/bootstrap.tsx"
import type { BlogBootstrap } from "./blog/types.ts"
import { Toaster } from "./components/ui/toaster.tsx"
import { init_posthog } from "./utils/analytics.ts"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

init_posthog()

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 1.0,
    ignoreErrors: [
      // The server's response while a deploy's migration runs ahead of the old instances; it stops
      // once they are replaced (FRONTEND-6D).
      "cached plan must not change result type",
      // Outlook / Microsoft Defender Safe Links scanning a mailed link, not a person (FRONTEND-1K).
      "Object Not Found Matching Id",
      // api_fetch's own message for a request that never reached us (FRONTEND-6E). The page already
      // tells the person; a server that is really down shows in uptime checks and server errors.
      "There is a problem with your internet connection",
    ],
    // replaysOnErrorSampleRate: 1.0,
  })
}

function read_blog_bootstrap_from_dom(): BlogBootstrap {
  if (typeof window === "undefined") {
    return null
  }
  const el = document.getElementById("blog-bootstrap-json")
  const raw = el?.textContent?.trim()
  if (!raw || raw === "__BLOG_BOOTSTRAP_JSON__") {
    return null
  }
  try {
    return JSON.parse(raw) as BlogBootstrap
  } catch {
    return null
  }
}

render(
  <BlogBootstrapProvider value={read_blog_bootstrap_from_dom()}>
    <>
      <Routes />
      <Toaster />
    </>
  </BlogBootstrapProvider>,
  document.getElementById("app") as HTMLElement
)
